import { useState } from 'react'
import { makeStyles } from '@material-ui/core/styles'

import { Box, Divider, Theme, Typography } from '@material-ui/core'
import useMediaQuery from '@material-ui/core/useMediaQuery'
import { MonthlyDatum, Segment } from './types'
import GraphView from './GraphView'
import TableView from './TableView'
import Toggle from './Toggle'

type StackedBarByMonthGroupProps<D> = {
  data: D[]
  segments: Segment<D>[]
  graphHeight?: number
  label: string
  TableProps?: Partial<Omit<React.ComponentProps<typeof TableView>, 'data' | 'segments'>>
}

const useStyles = makeStyles((theme) => ({
  header: {
    fontSize: theme.typography.pxToRem(16),
    fontWeight: 400,
  },
}))

function StackedBarByMonthGroup<D extends MonthlyDatum>({
  data,
  segments,
  graphHeight = 387,
  label,
  TableProps,
}: StackedBarByMonthGroupProps<D>) {
  const { header } = useStyles()
  const isSmall = useMediaQuery((theme: Theme) => theme.breakpoints.down('xs'))
  const [explicitTableView, setExplicitTableView] = useState(false)

  const tableView = explicitTableView || isSmall

  return (
    <>
      <Box
        p={2}
        display="flex"
        justifyContent="space-between"
        alignItems="center"
      >
        <Typography
          variant="body1"
          className={header}
          component="h3"
        >
          {label} by Month
        </Typography>
        {!isSmall && (
          <Toggle
            isTableView={explicitTableView}
            toggle={() => setExplicitTableView(!explicitTableView)}
            label={`${label} by Month`}
          />
        )}
      </Box>
      <Divider light />
      <Box p={2}>
        {tableView ? (
          <TableView
            rowsPerPage={6}
            {...TableProps}
            data={data}
            segments={segments}
          />
        ) : (
          <GraphView
            label={label}
            data={data}
            segments={segments}
            height={graphHeight}
          />
        )}
      </Box>
    </>
  )
}

export default StackedBarByMonthGroup
